/**
 * Override these file in customer folder
 * to add custom authentication handlers
 */
var CUSTOM_AUTHENTICATION_HANDLERS = [];

export default CUSTOM_AUTHENTICATION_HANDLERS;
